<template>
    <div type="table" class="input materialReview">
        <table ref="table">
            <thead>
                <tr>
                    <th>
                        Dun
                    </th>
                    <th>
                        Secondary
                    </th>
                    <th>
                        Primary
                    </th>
                    <th>
                        Dosageform
                    </th>
                    <th>
                        Api
                    </th>
                    <th>
                        Ancillary
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in getMaterialTableRows(formValue)">
                    <td>
                        {{item.dunName}}
                    </td>

                    <td>
                        <div v-if="item.primaryPackages.length > 0">
                            <div v-for="(secondary) in item.secondaryPackages">
                                {{secondary.name}} - ({{secondary.quantity}} x {{secondary.pmName}})
                            </div>
                        </div>
                        <div v-else>
                            Please associate dun to a secondary packaging
                        </div>
                    </td>
                    <td>
                        <div v-if="item.primaryPackages.length > 0">
                            <div v-for="(primary) in item.primaryPackages">
                                {{primary.name}} - ({{primary.dfQuantity}} x {{primary.dfName}})
                            </div>
                        </div>
                        <div v-else>
                            Please associate a primary package to a secondary package
                        </div>
                    </td>
                    <td>
                        <div v-if="item.dosageForms.length > 0">
                            <div v-for="(df) in item.dosageForms">
                                {{df.name}} - ({{df.quantity}} x {{df.unitName}})
                            </div>
                        </div>
                        <div v-else>
                            Please associate dosageform to a primary package.
                        </div>
                    </td>
                    <td>
                        <div v-if="item.apis.length > 0">
                            <div v-for="(api) in item.apis">
                                <div v-if="api.name !== ''">
                                    {{api.name}} - ({{api.quantity}} x {{api.unitName}})
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            Please associate dosageform to a primary package.
                        </div>
                    </td>
                    <td>
                        <div v-for="(ancillary) in item.ancillaryEquipments">
                            {{ancillary.name}} x {{ancillary.quantity}}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    import InputField from "./InputField.vue"
    import HelperBox from "../HelperBox.vue"
    
    import { Debug } from "@sentry/integrations";
    export default {
        components: {
            InputField,
            HelperBox
        },
        name: "MaterialReviewTable",
        props: {
            input: {
                type: Object,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        methods: {
            getMaterialTableRows(data) {


                let list = [];

                var thisReference = this;
                
                if (!thisReference.NullOrUndefined(data) && !thisReference.NullOrUndefined(data.dispensingUnits)) {
                    for (var i = 0; i < data.dispensingUnits.length; i++) {

                        var dispensingUnit = data.dispensingUnits[i];
                        var primaryPackages = [];
                        var secondaryPackages = [];
                        var dosageForms = [];
                        var apis = [];
                        var ancillaryEquipments = [];
                        dispensingUnit.secondaryPackages.filter(x => x.secondaryPackages !== '').forEach(sp => {
                              //this is ugly a.f., but the id's are not valid in secondary package under a dun in json....
                              //and to make it even more ugly a.f we find the secondary package id in in "secondaryPackages.secondaryPackages"...
                              var secondaryPackage = data.secondaryPackages.find(x => x.id === sp.secondaryPackages);
                              var primaryPackage = data.primaryPackages.find(pm => pm.id === secondaryPackage.primaryPackageId);
                              
                            
                              if (!thisReference.NullOrUndefined(primaryPackage)) {
                                //debugger;

                                console.log("primaryPackage.value.dosageFormId: " + primaryPackage.value.dosageFormId);
                                let dosageFormId = primaryPackage.value.dosageFormId;
                                let dosageFormName = "Please associate dosage form";
                                //debugger;
                                if (!thisReference.NullOrUndefined(data.dosageForms)) {
                                  let df = data.dosageForms.find(y => y.id === dosageFormId);
                                  if (!thisReference.NullOrUndefined(df)) {
                                    dosageFormName = df.name;
                                  }
                                }


                                primaryPackages.push(
                                    {
                                      "name": primaryPackage.name,
                                      "dfQuantity": primaryPackage.value.dosageFormQuantity,
                                      "dfName": dosageFormName,
                                      "dfId": dosageFormId
                                    }
                                );
                              }

                              if (!thisReference.NullOrUndefined(secondaryPackage)) {
                                secondaryPackages.push
                                (
                                    {
                                      "name": secondaryPackage.name,
                                      "quantity": sp.quantity,
                                      "pmName": !thisReference.NullOrUndefined(primaryPackage) ? primaryPackage.name : "Please associate a primary package.",
                                      "pmQuantity": !thisReference.NullOrUndefined(secondaryPackage.primaryPackageQuantity) ? secondaryPackage.primaryPackageQuantity : 0
                                    }
                                );
                              }

                            }
                          
                        );

                        primaryPackages.forEach(pp => {
                            var rootDosageform = data.dosageForms.find(df => df.id === pp.dfId);

                            if (!thisReference.NullOrUndefined(rootDosageform)) {
                                dosageForms.push
                                    (
                                        {
                                            "name": rootDosageform.name,
                                            "quantity": pp.dosageFormQuantity,
                                            "unitName": (rootDosageform.type.unit.name !== "") ? rootDosageform.type.unit.name : "please choose unit"
                                        }
                                    );
                                apis.push
                                    (
                                        {
                                            "name": rootDosageform.activeIngredient.value.name,
                                            "quantity": rootDosageform.activeIngredient.quantity,
                                            "unitName": (rootDosageform.activeIngredient.unit.name !== "") ? rootDosageform.activeIngredient.unit.name : "please choose unit"
                                        }
                                    );
                            }
                        }
                        );



                        if (!thisReference.NullOrUndefined(data.ancillaryEquipments) && !thisReference.NullOrUndefined(dispensingUnit)) {
                            ancillaryEquipments = data.ancillaryEquipments.filter(x => !thisReference.NullOrUndefined(x.dispensingUnits) && x.dispensingUnits.find(y => y.dispensingUnit === dispensingUnit.id));
                        }
                        var row =
                        {
                            "dunName": !thisReference.NullOrUndefined(dispensingUnit) ? dispensingUnit.name : "",
                            "secondaryPackages": secondaryPackages,
                            "primaryPackages": primaryPackages,
                            "dosageForms": dosageForms,
                            "apis": apis,
                            "ancillaryEquipments": !thisReference.NullOrUndefined(ancillaryEquipments) ? ancillaryEquipments.map(function (ae) {
                                return {
                                    "name": ae.name,
                                    "quantity": !thisReference.NullOrUndefined(ae.dispensingUnits) ? ae.dispensingUnits.find(y => y.dispensingUnit === dispensingUnit.id).quantity : 0
                                };
                            }) : []
                        };

                        list.push(row);
                    }
                }
                return list;
            }
        },
        watch: {
            "formValue.dosageForms": {
                handler: function () {                    
                    this.getMaterialTableRows(this.formValue);
                },
                deep: true
            },
            "formValue.primaryPackages": {
                handler: function () {
                    this.getMaterialTableRows(this.formValue);
                },
                deep: true
            }
            ,
            "formValue.secondaryPackages": {
                handler: function () {
                    this.getMaterialTableRows(this.formValue);
                },
                deep: true
            }
            ,
            "formValue.dispensingUnits": {
                handler: function () {
                    this.getMaterialTableRows(this.formValue);
                },
                deep: true
            }
        }
    }
</script>